import { StorageAPI } from 'clients';
import { Navigate } from 'react-router-dom';
import { PERSISTENT_PREFIX } from 'src/core/utils/StorageAPI';
import { getAnyPresetDeviceId } from 'utils/RouteUtil';
import { KIOSK_LOCATION, SELECTED_LOCATION } from 'vd-constants';

const ConfigMiddleware = ({ defaultPath }) => {
  const deviceId = getAnyPresetDeviceId();

  console.log('Page address', window.location);
  console.log('Path name', window.location?.pathname);
  console.log('Device ID from the URL', deviceId);

  if (window.location?.pathname === '/start-qnap-kiosk') {
    const kioskDeviceId = location?.search?.match(/\?deviceId=(.*)/)?.[1];
    console.log('Store the device ID to KIOSK_LOCATION', kioskDeviceId);

    StorageAPI.storeLocally(PERSISTENT_PREFIX + KIOSK_LOCATION, kioskDeviceId);
  }

  if (deviceId) {
    StorageAPI.storeLocally(SELECTED_LOCATION, deviceId);

    console.log('Store the device ID to SELECTED_LOCATION');
  } else {
    StorageAPI.removeLocally(SELECTED_LOCATION);

    console.log('Remove the device ID from SELECTED_LOCATION');
  }

  return <Navigate to={defaultPath} />;
};

export default ConfigMiddleware;
